
import 'moment';
import 'bootstrap';
import 'bootstrap-select';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';
import 'slick-carousel';
import '@glidejs/glide';
import Glide, { Controls, Breakpoints } from '@glidejs/glide';
window.Glide = Glide;
import 'tempusdominus-bootstrap-4';

import '../Scripts/postcode-lookup-enabled-countries';

import './scripts/options';
import './scripts/retailers/screwfix/options';

import './scripts/animated-egifts';
import './scripts/choose-product';
import './scripts/datepicker';
import './scripts/egift-preview';
import './scripts/email-validation';
import './scripts/password-validation';
import './scripts/helpers';
import './scripts/phone-number-validation';
import './scripts/form-validation';
import './scripts/modal-link';
import './scripts/payment';
import './scripts/previous-address-picker';
import './scripts/update-order';

import './scripts/retailers/screwfix/carousel.js';
import './scripts/retailers/screwfix/gift-delivery';
import './scripts/retailers/screwfix/page-expander.js';
import './scripts/retailers/screwfix/gift-value.js';
import './scripts/retailers/screwfix/choose-product.js';
import './scripts/retailers/screwfix/form-validation.js';

import './screwfix.scss';
